/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-destructuring */
import { pr } from '@/utils/pxToRem';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { genLinkSeoForVexPage } from '@/utils/genLinkSeo';
import { FC } from 'react';
import { style } from '@/styles/globals';
import CityMapping from '@/mappings/airport_vn.json';
import { styled } from '@mui/system';

interface CompanyToRouteVcmsProps {
  startPoint?: any;
  toPoint?: any;
  airline?: string
  excludedAirlines?: string[]
  title?: string;
  isEN?: boolean;
}

const Title = styled('h3')`
  color: ${style.primary.black}
`;

export const Airlines_Name = {
  VN: 'Vietnam Airlines',
  VJ: 'Vietjet',
  QH: 'Bamboo',
  VU: 'Vietravel Airlines',
  BL: 'Pacific Airlines',

} as any;

export const Airlines_Code = {
  VN: 'vietnam-airlines',
  VJ: 'vietjet-air',
  QH: 'bamboo-airways',
  VU: 'vietravel-airlines',
  BL: 'pacific-airlines',
} as any;

const CompanyToRouteVcms: FC<CompanyToRouteVcmsProps> = (props) => {
  const {
    startPoint,
    toPoint,
    airline,
    excludedAirlines,
    title,
    isEN,
  } = props;
  let airlines = ['VN', 'VJ', 'QH', 'VU'];
  // eslint-disable-next-line eqeqeq
  const startPointEn = CityMapping.airports.find((e) => e.VxrAreaParentId == startPoint?.id)?.CityName_En || '';
  // eslint-disable-next-line eqeqeq
  const toPointEn = CityMapping.airports.find((e) => e.VxrAreaParentId == toPoint?.id)?.CityName_En || '';
  if (airline) {
    airlines = [Object.keys(Airlines_Code).find((code: any) => Airlines_Code[code] === airline) || ''];
  } else if (excludedAirlines) {
    airlines = airlines.filter((x) => !excludedAirlines.includes(x));
  }

  const startPointName = isEN ? startPointEn : startPoint.location;
  const toPointName = isEN ? toPointEn : toPoint.location;
  const toText = isEN ? 'to' : 'đi';
  const fromText = isEN ? 'from' : 'từ';
  const flightText = isEN ? 'flights tickets' : '';

  return (
    <Box>
      <Title>{title || ''}</Title>
      <Box sx={{
        flexDirection: 'column',
        marginTop: pr`16px`,
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
      }}
      >
        {airlines.map((airportCode: string) => {
          let contentText = '';
          if (startPoint && toPoint) {
            contentText = `${isEN ? 'Cheap' : 'Vé máy bay'} ${Airlines_Name[airportCode]} ${flightText} ${fromText} ${startPointName} ${toText} ${toPointName}`;
          } else if (startPoint) {
            contentText = `${isEN ? 'Cheap' : 'Vé máy bay'} ${Airlines_Name[airportCode]} ${flightText} ${fromText} ${startPointName}`;
          } else if (toPoint) {
            contentText = `${isEN ? 'Cheap' : 'Vé máy bay'} ${Airlines_Name[airportCode]} ${flightText} ${toText} ${toPointName}`;
          }

          return (
            <Link
              sx={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '20px',
                textDecoration: 'none',
                color: `${style.primary.blue}`,
                textDecorationLine: 'underline',
                textDecorationColor: `${style.primary.blue}`,
              }}
              target="_blank"
              href={genLinkSeoForVexPage({
                startName: startPoint?.location,
                startId: startPoint?.id,
                startStateName: startPoint?.stateName,
                endName: toPoint?.location,
                endId: toPoint?.id,
                endStateName: toPoint?.stateName,
                company: Airlines_Code[airportCode],
              })}
              key={airportCode}
            >
              {contentText}
            </Link>
          );
        })}
      </Box>
    </Box>
  );
};

export default CompanyToRouteVcms;
